export default "__VITE_ASSET__CTaWhy0o__"